import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const VerticalNavbar = () => {
  const [isManagerDropdownOpen, setIsManagerDropdownOpen] = useState(false);
  const [isLeadDropdownOpen, setIsLeadDropdownOpen] = useState(false);
  const [isEmployeeDropdownOpen, setIsEmployeeDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isGreetingsDropdownOpen, setIsGreetingsDropdownOpen] = useState(false);
  const [isWatiDropdownOpen, setIsWatiDropdownOpen] = useState(false);
  const [isPaymentsDropdownOpen, setIsPaymentsDropdownOpen] = useState(false);

  const userRole = localStorage.getItem('role'); // Get role from localStorage
  
  const toggleManagerDropdown = () => {
    setIsManagerDropdownOpen(!isManagerDropdownOpen);
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false); // Close Lead dropdown if open
  };

  const toggleLeadDropdown = () => {
    setIsLeadDropdownOpen(!isLeadDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false); // Close Manager dropdown if open
  };

  const toggleEmployeeDropdown = () => {
    setIsEmployeeDropdownOpen(!isEmployeeDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false); // Close Manager dropdown if open
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false); // Close Lead dropdown if open
  };

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false);
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false);
    if (isEmployeeDropdownOpen) setIsEmployeeDropdownOpen(false);
  };

  const toggleGreetingsDropdown = () => {
    setIsGreetingsDropdownOpen(!isGreetingsDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false);
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false);
    if (isEmployeeDropdownOpen) setIsEmployeeDropdownOpen(false);
    if (isUserDropdownOpen) setIsUserDropdownOpen(false);
  };

  const toggleWatiDropdown = () => {
    setIsWatiDropdownOpen(!isWatiDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false);
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false);
    if (isEmployeeDropdownOpen) setIsEmployeeDropdownOpen(false);
    if (isUserDropdownOpen) setIsUserDropdownOpen(false);
    if (isGreetingsDropdownOpen) setIsGreetingsDropdownOpen(false);
  };

  const togglePaymentsDropdown = () => {
    setIsPaymentsDropdownOpen(!isPaymentsDropdownOpen);
    if (isManagerDropdownOpen) setIsManagerDropdownOpen(false);
    if (isLeadDropdownOpen) setIsLeadDropdownOpen(false);
    if (isEmployeeDropdownOpen) setIsEmployeeDropdownOpen(false);
    if (isUserDropdownOpen) setIsUserDropdownOpen(false);
    if (isGreetingsDropdownOpen) setIsGreetingsDropdownOpen(false);
    if (isWatiDropdownOpen) setIsWatiDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const navbar = document.getElementById('vertical-navbar');
      if (navbar && !navbar.contains(event.target)) {
        setIsManagerDropdownOpen(false);
        setIsLeadDropdownOpen(false);
        setIsEmployeeDropdownOpen(false);
        setIsUserDropdownOpen(false);
        setIsGreetingsDropdownOpen(false);
        setIsWatiDropdownOpen(false);
        setIsPaymentsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <Navbar id="vertical-navbar" className="navbar navbar-expand-lg navbar-light flex-column p-3" style={{ width: '250px', height: '100vh' }}>
      {/* Logo at the top */}
      <div className="mb-4">
        <img src="https://aksharafinalytics.com/wp-content/uploads/elementor/thumbs/akfin-qgepick2gc4b4m3xfynr658qlgki21rx8vyqzuu9ys.png"  
          alt="Logo" className="img-fluid" style={{ maxWidth: '80%', margin: '0 auto' }} />
      </div>

      {/* Vertical navbar list */}
      <Nav className="flex-column w-100">
        {/* Admin-specific links */}
        {userRole === 'admin' && (
          <>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/"> Dashboard </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/PlanDetails"> Services </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AllWorkDoc">Work Docs </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AllReqDoc">Request Docs </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Assignedtasks">Tasks </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AllTickets">Tickets </Link>
            </Nav.Item>            

            {/* Employee Dropdown */}
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Employeelist">Employees </Link>
            </Nav.Item>

            {/* Manager Dropdown */}
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/mlist">Managers </Link>
            </Nav.Item>

            {/* Lead Dropdown */}
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Leadlist">Leads </Link>
            </Nav.Item>

            {/* User Dropdown */}
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Userlist">Users </Link>
            </Nav.Item>
            


            {/* Greetings Dropdown */}
            <NavDropdown 
              title={<><span>Message </span><span className={`ms-2 down ${isGreetingsDropdownOpen ? 'caret-up' : 'caret-down'}`}>&#x25BC;</span></>} 
              show={isGreetingsDropdownOpen} 
              onClick={toggleGreetingsDropdown}
            >              
              <NavDropdown.Item as={Link} to="/LeadSms"> LeadSms </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/GreetingSms"> GreetingSms </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/GST"> GST </NavDropdown.Item>            
              
            </NavDropdown>

            {/* Wati Dropdown */}
            <NavDropdown 
              title={<><span>Wati Message </span><span className={`ms-2 down ${isWatiDropdownOpen ? 'caret-up' : 'caret-down'}`}>&#x25BC;</span></>} 
              show={isWatiDropdownOpen} 
              onClick={toggleWatiDropdown}
            >
              <NavDropdown.Item as={Link} to="/Leadwait"> Leads </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/WatiGreetings"> GreetingSms </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/WatiGST"> GST </NavDropdown.Item>
              
            </NavDropdown>

            {/* Payments Dropdown */}            
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/WebTranscation">Web Transcations </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/payment">Transaction Details</Link>
            </Nav.Item>

            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AllReports">Reports</Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/PreformaInvoice">Proforma Invoice</Link>
            </Nav.Item>
          </>
        )}

        {/* Manager and Employee-specific links */}
        {(userRole === 'manager' || userRole === 'employee') && (
          <NavDropdown 
            title={<><span>Lead </span><span className={`ms-2 down ${isLeadDropdownOpen ? 'caret-up' : 'caret-down'}`}>&#x25BC;</span></>} 
            show={isLeadDropdownOpen} 
            onClick={toggleLeadDropdown}
          >
            <NavDropdown.Item as={Link} to="/Lead"> Add Lead </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/Leadby"> Leads </NavDropdown.Item>
          </NavDropdown>
        )}

        {(userRole === 'sale manager') && (
          <Nav.Item className="mb-1">
            <Link className="nav-link" to="/Leadlist">Leads </Link>
          </Nav.Item>
        )}

        {/* Manager-specific links */}
        {userRole === 'manager' && (
          <>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/PlanDetails"> Services </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/LeadUsers"> Lead Users </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Users"> Users </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/Emplist">Employees </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AssignedEmp">Tasks </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/MyTask"> My Task </Link>
            </Nav.Item>  
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/ManageTickets">Tickets </Link>
            </Nav.Item>    
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AssigningTickets">My Ticket </Link>
            </Nav.Item>               
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/WorkedDocs"> Worked Docs </Link>
            </Nav.Item> 
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/DocRequest">DocRequest</Link>
            </Nav.Item> 
            <NavDropdown 
              title={<><span>Message </span><span className={`ms-2 down ${isGreetingsDropdownOpen ? 'caret-up' : 'caret-down'}`}>&#x25BC;</span></>} 
              show={isGreetingsDropdownOpen} 
              onClick={toggleGreetingsDropdown}
            >
              <NavDropdown.Item as={Link} to="/GreetingSms"> GreetingSms </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/GST"> GST </NavDropdown.Item>
            </NavDropdown>

            {/* Wati Dropdown */}
            <NavDropdown 
              title={<><span>Wati Message </span><span className={`ms-2 down ${isWatiDropdownOpen ? 'caret-up' : 'caret-down'}`}>&#x25BC;</span></>} 
              show={isWatiDropdownOpen} 
              onClick={toggleWatiDropdown}
            >
              <NavDropdown.Item as={Link} to="/WatiGreetings"> GreetingSms </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/WatiGST"> GST </NavDropdown.Item>
            </NavDropdown>

          </>
        )}

        {/* User-specific links */}
        {userRole === 'employee' && (
          <>            
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AssignedTask">AssignedTask</Link>
            </Nav.Item> 
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/AssigningTickets"> Assigned Ticket </Link>
            </Nav.Item>  
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/TransferTicket"> Transfered Ticket </Link>
            </Nav.Item>          
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/WorkedDocs"> Worked Docs </Link>
            </Nav.Item> 
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/DocRequest">DocRequest</Link>
            </Nav.Item> 
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/EmpRaiseTicket">Raise Ticket</Link>
            </Nav.Item>
          </>
        )}

        {/* User-specific links */}
        {userRole === 'user' && (
          <>            
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/RaiseTicket"> Raise Ticket </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/UserTicket"> All Ticket </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/DisplayWorkedDoc"> Worked Documents </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/DisplayDocRequest"> Request Documents </Link>
            </Nav.Item>
            
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/UserQueries"> Queries </Link>
            </Nav.Item>
            <Nav.Item className="mb-1">
              <Link className="nav-link" to="/UserPayment"> Payments </Link>
            </Nav.Item>
          </>
        )}
      </Nav>
    </Navbar>
  );
};

export default VerticalNavbar;
